module.exports = __webpack_public_path__ + "static/media/megaWin.136266f2.mp3";